import React from "react";
import { Grid, Box } from "@mui/material";
import PharmacyDetailsPetPanel from "./PharmacyDetailsPetPanel";
import PharmacyDetailsHeader from "./PharmacyDetailsHeader";
import PharmacyDetailsTables from "./PharmacyDetailsTables";

const PharmacyDetailsView = ({ record, onBack }) => {
  if (!record) return null;

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container spacing={3}>
        {/* Left Panel: Pet & Owner Info */}
        <Grid item xs={12} md={3.5} lg={3}>
          <PharmacyDetailsPetPanel record={record} />
        </Grid>

        {/* Right Panel: Case Details & Tables */}
        <Grid item xs={12} md={8.5} lg={9}>
          <Box display="flex" flexDirection="column" gap={3}>
            <PharmacyDetailsHeader record={record} onBack={onBack} />
            <PharmacyDetailsTables record={record} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PharmacyDetailsView;
